import { FileWithPathAndPreview, UploadFileType } from './types';

export const isFileWithPathAndPreview = (
  obj: UploadFileType
): obj is FileWithPathAndPreview => 'preview' in obj;

export const getFileKey = (file: UploadFileType): string =>
  isFileWithPathAndPreview(file) ? file.name : file.id;
